<script>
import { UtcDate } from '@/helpers/date';
import BaseDate from './BaseDate';

import { computed } from '@vue/composition-api';
import useTimeZoneWarning from '@/composables/useTimeZoneWarning.js';

export default {
  name: 'question-date-of-birth',
  inject: [
    'isLeadgen',
  ],
  extends: BaseDate,
  props: {
    title: {
      validator: value => (typeof value === 'string') || value === false,
      default: function () {
        return this.defaultTitle;
      },
    },
    helpText: {
      validator: value => ['string', 'object'].includes(typeof value) || value === false,
      default: 'Insurance providers need to know this as it can affect your premium price.',
    },
  },
  data () {
    return {
      fields: {
        field: 'dateOfBirth',
      },
    };
  },
  computed: {
    getYearsOptions () {
      const maxDateOfBirthDate = new UtcDate().subYears(this.constants.INSURER_MIN_AGE);
      const end = maxDateOfBirthDate.getFullYear();
      const start = end - (this.constants.INSURER_MAX_AGE - this.constants.INSURER_MIN_AGE);
      return Array(end - start + 1).fill().map((_, idx) => start + idx).reverse();
    },
    defaultTitle () {
      return this.isAdditional ? 'What is their date of birth?' : 'What is your date of birth?';
    },
    dateValidationRules () {
      const defaultRules = {
        dateOfBirth: true,
        checkMinAge: true,
      };

      if (this.isLeadgen) return this.setLgValidationRules(this.validationRules);

      return this.validationRules ? this.validationRules.field : defaultRules;
    },
  },

  methods: {
    setLgValidationRules (rules) {
      const insuranceDateValue = this.stepData.dateOfInsuranceStart || null;
      const defaultRules = {
        checkMinAgeLg: insuranceDateValue,
        dateOfBirthLg: true,
      };

      if (!rules) return defaultRules;

      const validationRules = this.helpers.parseRules(
        this.validationRules[this.questionFields.field],
        this.stepData,
      );

      return {
        ...validationRules,
        checkMinAgeLg: insuranceDateValue,
      };
    },
  },

  setup (props) {
    const isWarningTextShown = computed((componentContext) => {
      return useTimeZoneWarning(
        props.formObserver,
        `${props.stepId}_${props.questionId}`,
        componentContext.dateValidationRules,
      );
    });

    return {
      isWarningTextShown,
    };
  },
};
</script>

<style lang="scss" scoped>
.base-date-wrapper::v-deep {
  .columns {
    display: block !important;

    & > .form-col {
      width: 100%;
    }

    .help-text {
      margin-bottom: 23px;
    }

    .form-row__help-text {
      margin-bottom: 25px;
    }

    .form-row-title,
    .form-row__label {
      margin-bottom: 12px;
    }
  }
}
</style>
